import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="py-8 md:py-12" style={{ backgroundColor: '#DFD0B8' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="md:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="/images/VESTRIOZ.png" 
                alt="VestrioZ Logo" 
                className="w-15 h-14 object-contain"
                onError={(e) => {
                  // Fallback to icon if logo image fails to load
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <div className="w-12 h-12 rounded-xl flex items-center justify-center shadow-lg" style={{ backgroundColor: '#393E46', display: 'none' }}>
                <i className="fas fa-exchange-alt text-white text-lg"></i>
              </div>
            </div>
            <p className="mb-4 sm:mb-6 text-sm sm:text-base" style={{ color: '#222831' }}>
              Share Style, Rent or Sell Fashion, Earn Money
            </p>
            
            <div className="flex space-x-4 sm:space-x-6">
              <button 
                style={{ color: '#222831' }} 
                aria-label="Facebook"
              >
                <i className="fab fa-facebook text-lg"></i>
              </button>
              <a 
                href="https://www.instagram.com/_vestrioz_?igsh=eXQydXRwYWprNWEz"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#222831' }} 
                aria-label="Instagram"
              >
                <i className="fab fa-instagram text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-sm sm:text-base" style={{ color: '#222831' }}>Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link 
                  to="/home" 
                  style={{ color: '#222831' }}
                >
                  Home
                </Link>
              </li>
              <li>
                <Link 
                  to="/rent-items" 
                  style={{ color: '#222831' }}
                >
                  Browse Items
                </Link>
              </li>
              <li>
                <Link 
                  to="/list-items" 
                  style={{ color: '#222831' }}
                >
                  List Items
                </Link>
              </li>
              <li>
                <Link 
                  to="/membership" 
                  style={{ color: '#222831' }}
                >
                  Membership
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-semibold mb-4 text-sm sm:text-base" style={{ color: '#222831' }}>Support</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link 
                  to="/contact" 
                  style={{ color: '#222831' }}
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <Link 
                  to="/cancellation-refund" 
                  style={{ color: '#222831' }}
                >
                  Refund Policy
                </Link>
              </li>
              <li>
                <Link 
                  to="/privacy-policy" 
                  style={{ color: '#222831' }}
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link 
                  to="/terms-of-service" 
                  style={{ color: '#222831' }}
                >
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold mb-4 text-sm sm:text-base" style={{ color: '#222831' }}>Contact</h4>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center" style={{ color: '#222831' }}>
                <i className="fas fa-envelope mr-2"></i>
                <a 
                  href="mailto:info.vestrioz@gmail.com"
                  style={{ color: '#222831' }}
                >
                  info.vestrioz@gmail.com
                </a>
              </li>
              <li className="flex items-center" style={{ color: '#222831' }}>
                <i className="fas fa-clock mr-2"></i>
                <span>24/7 Customer Support</span>
              </li>
              <li className="flex items-start" style={{ color: '#222831' }}>
                <i className="fas fa-map-marker-alt mr-2 mt-1"></i>
                <span>Surat, Gujarat, India</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t mt-8 pt-6" style={{ borderColor: '#393E46' }}>
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm mb-4 md:mb-0" style={{ color: '#222831' }}>
              © 2026 VestrioZ. All rights reserved | Created by{' '}
              <a 
                href="https://nayvora.in" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:underline font-medium"
                style={{ color: '#222831' }}
              >
                Nayvora Solutions
              </a>
            </p>
            <div className="flex space-x-6 text-sm">
              <Link 
                to="/contact" 
                style={{ color: '#222831' }}
              >
                Contact
              </Link>
              <Link 
                to="/privacy-policy" 
                style={{ color: '#222831' }}
              >
                Privacy
              </Link>
              <Link 
                to="/terms-of-service" 
                style={{ color: '#222831' }}
              >
                Terms
              </Link>
              <Link 
                to="/cancellation-refund" 
                style={{ color: '#222831' }}
              >
                Refunds
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;